export type ThemePreference = 'light' | 'dark' | 'system';

export const THEME_KEY = 'theme';
const LEGACY_PLANNER_KEY = 'planner-theme';

const isValid = (v: unknown): v is ThemePreference =>
  v === 'light' || v === 'dark' || v === 'system';

export function resolveIsDark(
  pref: ThemePreference,
  systemPrefersDark: boolean,
): boolean {
  if (pref === 'dark') return true;
  if (pref === 'light') return false;
  return systemPrefersDark;
}

export function writeStoredPreference(pref: ThemePreference): void {
  try {
    window.localStorage.setItem(THEME_KEY, pref);
  } catch {
    // swallow: modo privado / quota
  }
}

export function readStoredPreference(): ThemePreference {
  // Default (sem preferência salva) é 'light'.
  if (typeof window === 'undefined') return 'light';
  try {
    const v = window.localStorage.getItem(THEME_KEY);
    if (isValid(v)) return v;

    // Migração única do tema legado do Planner.
    const legacy = window.localStorage.getItem(LEGACY_PLANNER_KEY);
    if (legacy === 'dark' || legacy === 'light') {
      writeStoredPreference(legacy);
      return legacy;
    }
    return 'light';
  } catch {
    return 'light';
  }
}
